'use strict';

/*global roundToDecimals*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/

(function ($) {

  function CapacityPlanning($widget) {
    this.$widget = $widget;

    this.init();
  }

  CapacityPlanning.prototype = $.extend({}, {
    constructor: 'CapacityPlanning',

    //--------------------------------------------------------------------------

    updateSummaryWrapper: function updateSummaryWrapper($wrapper, tasks, hours, capacity) {
      var _this = this;

      capacity = capacity || 0;

      $wrapper.find('.hours').text(roundToDecimals(hours, 2));
      $wrapper.find('.tasks').text(tasks);

      if (capacity > 0) {
        var loading = roundToDecimals((hours / capacity) * 100, 1);

        var loadingClass = 'danger';
        if (loading < 50) {
          loadingClass = 'success';
        } else if (loading >= 50 && loading < 85) {
          loadingClass = 'warning';
        }

        $wrapper.find('.loading-wrapper').attr({ class: 'loading-wrapper text-' + loadingClass });
        $wrapper.find('.loading').text(loading);
      }

      return _this;
    },

    updateResourceSummaryCell: function updateResourceSummaryCell($resourceSummaryCell, $projectSPOResourceCell, statusId) {
      var _this = this;

      var tasks = 0;
      var hours = 0;
      var capacity = parseFloat($resourceSummaryCell.find('.capacity').text());

      $projectSPOResourceCell.find('.project-spo-resource-wrapper tr' + (statusId ? '[data-status_id="' + statusId + '"]' : '')).each(function () {
        tasks++;
        hours += parseFloat($(this).find('.hours').text()) || 0;
      });

      _this.updateSummaryWrapper($resourceSummaryCell, tasks, hours, capacity);

      return _this;
    },

    updateTotalSummaryCell: function updateTotalSummaryCell($resouceSummaryRows, $summaryCell, $summary, statusId) {
      var _this = this;

      var tasks = 0;
      var hours = 0;

      $resouceSummaryRows.each(function () {
        var $resouceSummaryCell = $(this).find('> td').eq($summaryCell.index());

        tasks += parseFloat($resouceSummaryCell.find((statusId ? '.status-wrapper[data-status_id="' + statusId + '"] ' : '') + '.tasks').text()) || 0;
        hours += parseFloat($resouceSummaryCell.find((statusId ? '.status-wrapper[data-status_id="' + statusId + '"] ' : '') + '.hours').text()) || 0;
      });

      _this.updateSummaryWrapper($summary, tasks, hours, parseFloat($summaryCell.find('.capacity').text()));

      return _this;
    },

    updateResourceSummary: function updateResourceSummary($projectSPOResourceRow) {
      var _this = this;

      var $resourceSummaryRow = $projectSPOResourceRow.prev();

      var $projectSPOResourceCells = $projectSPOResourceRow.find('.recountable-cell');
      $projectSPOResourceCells.each(function () {
        var $projectSPOResourceCell = $(this);
        var $resourceSummaryCell = $resourceSummaryRow.find('> td').eq($projectSPOResourceCell.index());

        if ($projectSPOResourceCells.last().is($projectSPOResourceCell)) {
          //posledni sloupec musim projit dle stavu
          $resourceSummaryCell.find('.status-wrapper').each(function () {
            _this.updateResourceSummaryCell($(this), $projectSPOResourceCell, $(this).data('status_id'));
          });
        } else {
          _this.updateResourceSummaryCell($resourceSummaryCell, $projectSPOResourceCell);
        }
      });

      return _this;
    },

    updateTotalSummary: function updateTotalSummary() {
      var _this = this;

			/*
      var $totalSummaryRow = _this.$widget.find('.total-summary-row');
      var $resouceSummaryRows = _this.$widget.find('.resource-summary-row');

      var $totalSummaryCells = $totalSummaryRow.find('.recountable-cell');
      $totalSummaryCells.each(function () {
        var $summaryCell = $(this);

        if ($totalSummaryCells.last().is($summaryCell)) {
          //posledni sloupec musim projid dle stavu
          $totalSummaryCells.find('.status-wrapper').each(function () {
            _this.updateTotalSummaryCell($resouceSummaryRows, $summaryCell, $(this), $(this).data('status_id'));
          });
        } else {
          _this.updateTotalSummaryCell($resouceSummaryRows, $summaryCell, $summaryCell);
        }
      });
			*/

      return _this;
    },

    //--------------------------------------------------------------------------

    saveProjectSPOResourcePlan: function saveProjectSPOResourcePlan(projectSPOResourceRID, planDate) {
      var _this = this;

      blockElement(_this.$widget);
      $.get(services.get('router').path('project_job_queue_plan', { jobQueueRID: projectSPOResourceRID }), { planDate: planDate }, function (res) {
        unBlockElement(_this.$widget);
        if (res.msg !== 'SUCCESS') {
          services.get('notifications').viewErrorMessage();
        }
      });

      return _this;
    },

    //--------------------------------------------------------------------------

    initData: function initData() {
      var _this = this;

			_this.$widget.find('.project-spo-resource').draggable({
				helper: 'clone',
				containment: _this.$widget,
				appendTo: _this.$widget,
				zIndex: 100,
				cursorAt: { left: 25, top: 10 },
				classes: { 'ui-draggable-dragging': 'project-spo-resource-dragged' },
				start: function () {
					var $source = $(this);

					$source.closest('.project-spo-resource-target').parent().find('.project-spo-resource-target').addClass('project-spo-resource-target-acceptable');
				},

				stop: function () {
					var $source = $(this);

					$source.closest('.project-spo-resource-target').parent().find('.project-spo-resource-target').removeClass('project-spo-resource-target-acceptable');
				}
			});

			_this.$widget.find('.project-spo-resource-target').droppable({
				accept: '.project-spo-resource',
				tolerance: 'pointer',
				drop: function (event, ui) {
					var $source = ui.draggable;
					var $target = $(this);

					if ($source.closest('.draggable-wrapper').is($target.closest('.draggable-wrapper'))) {
						$target.find('.project-spo-resource-wrapper').append($source.closest('tr'));

						_this.saveProjectSPOResourcePlan($source.data('rid'), $target.data('plan_date'));
						_this.updateResourceSummary($source.closest('.draggable-wrapper'));
						_this.updateTotalSummary();
						_this.$widget.find('.table-fixed-columns').trigger('resizeTable');
					}

					_this.$widget.find('.project-spo-resource-target-hover').removeClass('project-spo-resource-target-hover');
				},

				over: function (event, ui) {
					var $source = ui.draggable;
					var $target = $(this);

					_this.$widget.find('.project-spo-resource-target-hover').removeClass('project-spo-resource-target-hover');
					if ($source.closest('.draggable-wrapper').is($target.closest('.draggable-wrapper'))) {
						$target.closest('.ui-droppable').addClass('project-spo-resource-target-hover');
					}
				},

				out: function () {
					var $target = $(this);

					$target.closest('.ui-droppable').removeClass('project-spo-resource-target-hover');
				}
			});

			_this.$widget.find('.table-fixed-columns').trigger('resizeTable');

      return _this;
    },

    init: function init() {
      var _this = this;

      return _this;
    }
  });

  var methods = {
    init: function (/*options*/) {
      /*var opts = $.extend({}, $.fn.widget_capacityPlanning.defaults, options);*/

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('widget-capacity-planning-init')) {
          return;
        }

        $this.addClass('widget-capacity-planning-init');

        $this.data('widget', new CapacityPlanning($this));

        $this.on('loadWidgetContent', function () {
          $this.data('widget').initData();
        });

        $this.data('widget').initData();

      });
    }
  };

  $.fn.widget_capacityPlanning = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.widget_capacityPlanning');
    }

  };

  $.fn.widget_capacityPlanning.defaults = {};

})(jQuery);
